import { Tooltip } from 'antd';
const ModuleEngineIcon = ({
  type,
  width = '52px',
  height = '39px'
}) => <Tooltip title={type} data-sentry-element="Tooltip" data-sentry-component="ModuleEngineIcon" data-sentry-source-file="ModuleEngineIcon.jsx">
    <img src={`/assets/module-engine-icons/${(type || '').toLowerCase().replace(' ', '_')}.png`} alt={type} width={width} height={height} />
  </Tooltip>;
export default ModuleEngineIcon;